/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPFREQUENCY = {
    Yearly: '1',
    HalfYearly: '2',
    Quarterly: '4',
    Monthly: '12',
    Single: '0'
} as const;
export type IAPFREQUENCY = typeof IAPFREQUENCY[keyof typeof IAPFREQUENCY];


export function IAPFREQUENCYFromJSON(json: any): IAPFREQUENCY {
    return IAPFREQUENCYFromJSONTyped(json, false);
}

export function IAPFREQUENCYFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPFREQUENCY {
    return json as IAPFREQUENCY;
}

export function IAPFREQUENCYToJSON(value?: IAPFREQUENCY | null): any {
    return value as any;
}

